import styled from 'styled-components'

export const Paper = styled.div`
  background-color: ${({ theme }) => theme.colors.foregroundPaper};
  border-radius: 12px;
  min-height: 300px;
  width: 100%;
  padding: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
`

export const DataContainer = styled.div`
  padding: 8px;
  gap: 10px;
`

export const SeparatorContainer = styled.div`
  padding: 8px;
`
